module.exports = __webpack_public_path__ + "img/icon_window.54a53755.svg";